import { CallReceiveInfo } from '@/postMessage/types'
import Vue from 'vue'
import store from '@/store'
import router from '@/router'

type CallPayload = Omit<
  CallReceiveInfo,
  'videoEnable' | 'fromUser' | 'fromOccupation'
>
type CallSubPayload = Pick<CallReceiveInfo, 'fromUser' | 'fromOccupation'>

type PushMessage = {
  tap?: 'background'
  messageType: string
  type: 'message' | 'call'
  payload?: string
  payload2?: string
}

const PushHandler = {
  handleFCMToken(token: string) {
    store.dispatch('appSettings/update', { FCMToken: token })
  },
  handlePermissionDenied() {
    // TODO: メッセージを表示する必要あり?
  },
  handleMessage(message: PushMessage) {
    if (!message.type) throw new Error('push message is invalid')
    if (!message.tap) return //フォアグラウンド時にreturn
    switch (message.type) {
      case 'message':
        this._handleShowMessage()
        break
      case 'call':
        this._handleCall(message.payload, message.payload2)
        break
    }
  },
  _handleShowMessage() {
    const user = store.getters['user/userInfo']
    if (user.isWorker) {
      store.dispatch('message/displayMessageModal', true)
    } else {
      router.push({ name: 'PatientMessage' })
    }
  },
  _handleCall(payload?: string, payload2?: string) {
    if (!payload || !payload2) throw new Error('push does not have payload')
    try {
      const user = store.getters['user/userInfo']
      const callInfo = JSON.parse(payload) as CallPayload
      const userInfo = JSON.parse(payload2) as CallSubPayload
      store.commit('videoCallRoom/setRequestPendingRoomId', null)
      Vue.$postMessage.showCallReceiveView({
        ...callInfo,
        ...userInfo,
        videoEnable: true,
        isPatient: user.isPatient
      })
    } catch (e) {
      console.error(e)
    }
  }
}

export default PushHandler
